export interface IFileReference {
  file: string
  filename?: string
}

export function isFileReference(value: unknown): value is IFileReference {
  return (
    typeof value === 'object'
    && value !== null
    && 'file' in value
    && typeof (value as IFileReference).file === 'string'
  )
}

export function getFileNameFromUrl(fileUrl: string, fallback = 'Файл'): string {
  if (!fileUrl || typeof fileUrl !== 'string') {
    return fallback
  }

  const parts = fileUrl.split('?')[0].split('/')
  const name = parts[parts.length - 1] || fallback

  try {
    return decodeURIComponent(name)
  } catch {
    return name
  }
}

export function resolveFileName(
  fileUrl: string,
  filename?: string | null,
  fallback = 'Файл',
): string {
  if (filename && typeof filename === 'string' && filename.trim()) {
    return filename.trim()
  }

  return getFileNameFromUrl(fileUrl, fallback)
}

export function resolveFileFromValue(value: unknown): IFileReference | null {
  if (typeof value === 'string' && value.trim()) {
    return { file: value.trim() }
  }

  if (isFileReference(value)) {
    return { file: value.file, filename: value.filename }
  }

  return null
}

export function resolveFileDisplayName(value: unknown, fallback = 'Файл'): string {
  const ref = resolveFileFromValue(value)
  if (!ref) {
    return fallback
  }

  return resolveFileName(ref.file, ref.filename, fallback)
}
